export enum TipoVinculoEnum {

  NotaFiscal_Guia
}
